import styled from 'styled-components';
import { Form as Unform } from '@unform/web';

export const Container = styled.div`
  height: calc(100vh - 8rem);
  width: 100%;
  max-width: 1400px;
  margin: 4rem auto 0;
  background-color: var(--gray-background);
  padding-top: 1rem;

  a {
    margin-left: 10rem;
    color: var(--gray-800);
    text-decoration: none;
    display: flex;
    align-items: center;
    svg {
      margin-right: 4px;
    }
  }

  h2 {
    margin-left: 10rem;
    margin-top: 1rem;
    font-size: 1.4rem;
    color: var(--light-blue);
  }

  @media (max-width: 850px) {
    height: calc(100vh - 4rem);
  }

`;
export const Form = styled(Unform)`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 1rem 10rem 1rem;
  max-width: 100%;
  justify-content: space-between;
  
  .body-form {
    display: flex;
    justify-content: space-between;
  }
  .mission-info {
    h4 {
      color: var(--dark-blue);
      margin-bottom: 1rem;
    }
    width: 30%;
    background-color: #fff;
    border-radius: 0.25rem;
    border: 1px solid var(--light-blue);
    padding: 1rem 2rem .5rem;
  }
  .small-inputs {
    display: flex;
    gap: .5rem;
  }

  .input-div {
    label {
      font-size: 0.9rem;
    }
  }

  .button-div {
    display: flex;
    width: 100%;
    justify-content: flex-end;

  }

  .submit-button {
    width: 7rem;
    font-weight: bold;
    margin-top: 1rem;
    font-size: 1rem;
    background: var(--light-green);
    border: 0;
    text-align: center;
    color: #fff;
    padding: 4px;
    border-radius: 0.25rem;
  }

  @media (max-width: 600px) {
    display: flex;
    width: 90%;
    overflow: auto;

    .body-form {
      display: flex;
      flex-direction: column;
    }

    .mission-info {
      width: 100%;
      margin-bottom: 1rem;
      margin: 0 auto 1rem;
    }
  }
`;
